export default {
    data() {
        return {
            table: 'wj',
            datas: {
                add: {
                }
            }
        };
    },
    created() {

        this._load();
    },
    methods: {

    },
};